// assets/product-custom-property.js
import { Component } from '@theme/component';

/**
 * @typedef {object} ProductCustomPropertyRefs
 * @property {HTMLInputElement | HTMLTextAreaElement} textInput - The text input.
 * @property {HTMLElement} characterCount - The character count element.
 */

/**
 * A custom element that manages product custom properties.
 * Initial fields may include punctuation, but are limited to four letters.
 * @extends Component<ProductCustomPropertyRefs>
 */
class ProductCustomProperty extends Component {
  handleInput() {
    const { textInput } = this.refs;

    if (textInput?.dataset.initialsField === 'true') {
      const maxLetters = Number(textInput.dataset.maxLetters || 4);
      const normalised = textInput.value
        .replace(/[^\p{L}.&\s'-]/gu, '')
        .toUpperCase();

      let letterCount = 0;
      let nextValue = '';

      for (const character of normalised) {
        const isLetter = /\p{L}/u.test(character);

        if (isLetter) {
          if (letterCount >= maxLetters) continue;
          letterCount += 1;
        }

        nextValue += character;
      }

      textInput.value = nextValue.slice(0, textInput.maxLength);
    }

    this.#updateCharacterCount();
  }

  #updateCharacterCount() {
    const { characterCount, textInput } = this.refs;
    if (!characterCount || !textInput) return;

    const maxLetters = Number(characterCount.dataset.maxLetters || 0);
    const currentLength = maxLetters
      ? (textInput.value.match(/\p{L}/gu) || []).length
      : textInput.value.length;
    const maxLength = maxLetters || textInput.maxLength;

    const template = characterCount.getAttribute('data-template');
    if (!template) return;

    characterCount.textContent = template
      .replace('[current]', currentLength.toString())
      .replace('[max]', maxLength.toString());
  }
}

if (!customElements.get('product-custom-property-component')) {
  customElements.define('product-custom-property-component', ProductCustomProperty);
}
